import dayjs from 'dayjs';
import { ITire } from 'app/shared/model/tire.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ITireGroove {
  id?: number;
  created?: string | null;
  groove?: number | null;
  odometer?: number | null;
  performance?: number | null;
  tire?: ITire | null;
  company?: ICompany | null;
  truckImplementId?: number | null;
}

export const defaultValue: Readonly<ITireGroove> = {};
